/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$$ as $$,
  rec_Bo as Bo,
  rec_Componente_t1_116_49 as Componente_t1_116_49,
  rec_DetalleIncidencia as DetalleIncidencia,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_e1 as e1,
  rec_y$ as y$,
} from "../../runtime/index.jsx";
export function ListaIncidencias(e) {
  let t = (0, ReactCompiler.c)(36),
    { items: n, onRecargar: r } = e,
    [i, a] = (0, React.useState)(null),
    [o, s] = (0, React.useState)(!1),
    c;
  t[0] === n ? (c = t[1]) : ((c = n.filter(e1)), (t[0] = n), (t[1] = c));
  let l = c,
    u;
  t[2] === n ? (u = t[3]) : ((u = n.filter($$)), (t[2] = n), (t[3] = u));
  let f = u,
    p = o ? n : f;
  if (n.length === 0) {
    let e;
    return (
      t[4] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((e = (
            <section
              className={`flex flex-col gap-3`}
              children={[
                <h2
                  className={`text-sm font-medium text-(--text-h) !m-0`}
                  children={`Lo que reportaste`}
                />,
                <p
                  className={`${Bo} text-sm text-(--text)`}
                  children={`Todavía no reportaste nada.`}
                />,
              ]}
            />
          )),
          (t[4] = e))
        : (e = t[4]),
      e
    );
  }
  let m;
  t[5] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((m = (
        <h2
          className={`text-sm font-medium text-(--text-h) !m-0`}
          children={`Lo que reportaste`}
        />
      )),
      (t[5] = m))
    : (m = t[5]);
  let h;
  t[6] !== f.length || t[7] !== l.length || t[8] !== n.length
    ? ((h = (
        <div
          className={`flex flex-wrap items-center justify-between gap-2`}
          children={[
            m,
            <span
              className={`text-xs text-(--text)`}
              children={[
                n.length,
                ` en total · `,
                l.length,
                ` resueltas · `,
                f.length,
                ` abiertas`,
              ]}
            />,
          ]}
        />
      )),
      (t[6] = f.length),
      (t[7] = l.length),
      (t[8] = n.length),
      (t[9] = h))
    : (h = t[9]);
  let _;
  t[10] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((_ = [
        {
          id: !1,
          label: `Abiertas`,
        },
        {
          id: !0,
          label: `Todas`,
        },
      ]),
      (t[10] = _))
    : (_ = t[10]);
  let v;
  t[11] === o
    ? (v = t[12])
    : ((v = (
        <div
          className={`flex flex-wrap gap-1 border-b border-(--border)`}
          children={_.map((e) => (
            <button
              key={String(e.id)}
              type={`button`}
              onClick={() => s(e.id)}
              className={`-mb-px min-h-11 border-b-2 px-3 py-2 text-sm transition ${o === e.id ? `border-(--accent) font-medium text-(--text-h)` : `border-transparent text-(--text) hover:text-(--text-h)`}`}
              children={e.label}
            />
          ))}
        />
      )),
      (t[11] = o),
      (t[12] = v));
  let y;
  t[13] === p.length
    ? (y = t[14])
    : ((y = p.length === 0 && (
        <p
          className={`rounded-2xl border border-(--border) bg-(--bg) p-4 text-sm text-(--success)`}
          children={`No te queda ninguna abierta. Todo lo que reportaste está cerrado.`}
        />
      )),
      (t[13] = p.length),
      (t[14] = y));
  let b;
  if (t[15] !== p) {
    let e;
    (t[17] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((e = (e) => (
          <li
            key={e.id}
            children={
              <button
                type={`button`}
                onClick={() => a(e.id)}
                className={`flex w-full flex-col gap-1 px-3 py-2 text-left active:scale-[0.99]`}
                children={[
                  <div
                    className={`flex items-center justify-between gap-2`}
                    children={[
                      <span
                        className={`text-sm font-medium text-(--text-h) !m-0`}
                        children={e.tipo}
                      />,
                      <Componente_t1_116_49 valor={e.estado} />,
                    ]}
                  />,
                  <span
                    className={`text-xs text-(--text)`}
                    children={e.ubicacion || e.fundo || `—`}
                  />,
                  <span
                    className={`text-xs text-(--text)`}
                    children={[
                      y$(e.reportadaEn),
                      ` · `,
                      e.area || `sin área todavía`,
                    ]}
                  />,
                ]}
              />
            }
          />
        )),
        (t[17] = e))
      : (e = t[17]),
      (b = p.map(e)),
      (t[15] = p),
      (t[16] = b));
  } else b = t[16];
  let x;
  t[18] === b
    ? (x = t[19])
    : ((x = (
        <ul
          className={`max-h-[60vh] divide-y divide-(--border) overflow-y-auto sm:hidden`}
          children={b}
        />
      )),
      (t[18] = b),
      (t[19] = x));
  let S;
  t[20] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((S = (
        <thead
          className={`border-b border-(--border) text-xs uppercase text-(--text)`}
          children={
            <tr
              children={[
                <th className={`px-3 py-2 font-medium`} children={`Código`} />,
                <th className={`px-3 py-2 font-medium`} children={`Qué`} />,
                <th className={`px-3 py-2 font-medium`} children={`Dónde`} />,
                <th className={`px-3 py-2 font-medium`} children={`Cuándo`} />,
                <th className={`px-3 py-2 font-medium`} children={`Área`} />,
                <th className={`px-3 py-2 font-medium`} children={`Estado`} />,
                <th className={`px-3 py-2`} />,
              ]}
            />
          }
        />
      )),
      (t[20] = S))
    : (S = t[20]);
  let C;
  if (t[21] !== p) {
    let e;
    (t[23] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((e = (e) => (
          <tr
            key={e.id}
            className={`border-b border-(--border) last:border-0`}
            children={[
              <td className={`px-3 py-2 text-(--text)`} children={e.codigo} />,
              <td className={`px-3 py-2 text-(--text-h)`} children={e.tipo} />,
              <td
                className={`px-3 py-2 text-(--text)`}
                children={e.ubicacion || e.fundo || `—`}
              />,
              <td
                className={`px-3 py-2 text-(--text)`}
                children={y$(e.reportadaEn)}
              />,
              <td
                className={`px-3 py-2 text-(--text)`}
                children={e.area || `—`}
              />,
              <td
                className={`px-3 py-2`}
                children={<Componente_t1_116_49 valor={e.estado} />}
              />,
              <td
                className={`px-3 py-2 text-right`}
                children={
                  <button
                    type={`button`}
                    onClick={() => a(e.id)}
                    className={`min-h-11 rounded-lg px-2 text-sm text-(--accent) hover:underline`}
                    children={`Ver`}
                  />
                }
              />,
            ]}
          />
        )),
        (t[23] = e))
      : (e = t[23]),
      (C = p.map(e)),
      (t[21] = p),
      (t[22] = C));
  } else C = t[22];
  let w;
  t[24] === C
    ? (w = t[25])
    : ((w = (
        <div
          className={`${Bo} hidden max-h-[60vh] overflow-auto p-0 sm:block`}
          children={
            <table
              className={`w-full text-left text-sm`}
              children={[S, <tbody children={C} />]}
            />
          }
        />
      )),
      (t[24] = C),
      (t[25] = w));
  let T;
  t[26] !== i || t[27] !== r
    ? ((T = i != null && (
        <DetalleIncidencia
          id={i}
          onCerrar={() => a(null)}
          onCambio={async () => {
            (a(null), await r());
          }}
        />
      )),
      (t[26] = i),
      (t[27] = r),
      (t[28] = T))
    : (T = t[28]);
  let E;
  return (
    t[29] !== w ||
    t[30] !== T ||
    t[31] !== h ||
    t[32] !== v ||
    t[33] !== y ||
    t[34] !== x
      ? ((E = (
          <section
            className={`flex flex-col gap-3`}
            children={[h, v, y, x, w, T]}
          />
        )),
        (t[29] = w),
        (t[30] = T),
        (t[31] = h),
        (t[32] = v),
        (t[33] = y),
        (t[34] = x),
        (t[35] = E))
      : (E = t[35]),
    E
  );
}
